var BaseViews = require('../base');
require('./modal/modal.scss');
var Modal = BaseViews.LayoutView.extend({
    className: 'fmcy-modal',
    template: require('./modal/modal.html'),
    initialize: function(options) {
        var self = this;
        this.options = _.defaults(
            options || {},
            {
                theme: 'dark',
                title: 'Sorry product cannot be found',
                description: 'The product potentially may have been discontinued. Please try searching above'
            }
        );
    },
    ui: {
      btnClose: '.fmcy-menu-item-btn-close'
    },
    triggers: {
      'click @ui.btnClose': 'close:clicked',
      'click': 'close:clicked'
    },
    regions: {
        contentRegion: '.fmcy-modal-content-region',
    },
    _onPopState: function (event) {
      this.trigger('close:clicked');
    },
    _onWindowKeyUp: function (event) {
      if (event.keyCode == 27) {
        this.trigger('close:clicked');
      }
    },
    _onWindowResize: function (event) {
      this.$el.width($(window).outerWidth());
      this.$el.height($(window).outerHeight());
    },
    onRender: function() {
      var self = this;
      $(window).on('resize.' + this.cid, _.bind(this._onWindowResize, this));
      $(window).on('keyup.' + this.cid, _.bind(this._onWindowKeyUp, this));
      $(window).on('popstate.' + this.cid, _.bind(this._onPopState, this));
      this._onWindowResize();
      BaseViews.LayoutView.prototype.onRender.call(self);
    },
    onDestroy: function () {
      $(window).off('keyup.' + this.cid);
      $(window).off('popstate.' + this.cid);
      $(window).off('resize.' + this.cid);
      BaseViews.LayoutView.prototype.onDestroy.call(self);
    },
    serializeData: function () {
        return {
            title: this.options.title,
            description: this.options.description
        };
    },
});

module.exports = Modal;



/** WEBPACK FOOTER **
 ** ./assets/js/common/modal/modal.js
 **/